import app from 'flarum/common/app';

app.initializers.add('rz-pazirik/flarum-discussion-gallery', function(app) {

  //console.log('[rz-pazirik/flarum-discussion-gallery] Hello, forum and admin!');
  
});



